<template>
  <div class="u-m-t-20 c-bg-fff u-height-200 c-border-t1">
    <div class="windowsWidth  ">
      <el-row :gutter="20">
        <el-col :span="14" class="u-m-t-20 u-text-center u-line-height-30 u-font-14">
          <div>白银市政协版权所有 Copyright@ 2018-2022 All Rights Reserved</div>
          <div>备案号：陇ICP备18000671号-1</div>
          <div>地址：甘肃省白银市白银区广场北路1号 联系电话：0943-8221485</div>
          <div>举报电话：0943—8221485 举报邮箱：byszx8305@126.com</div>
          <div>甘肃省互联网有害信息举报：<a href="http://www.gsjubao.cn/" target="_blank">http://www.gsjubao.cn/</a></div>
          <div>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62040202000292" target="_blank">
              <img src="../assets/0001.png" />
              甘公网安备 62040202000292号
            </a>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="u-flex u-row-evenly u-m-t-0 c-bg-fff u-p-t-10 u-p-b-10">
            <div v-for="(item, index) in imgList" :key="index" class="u-p-l-10 u-p-r-10 u-cursor">
              <el-image style="width: 100%;height: 150px;border: 2px solid #eaeaea;" :src="item.filePath" fit="fill"
                @click="imgItem = item, dialogVisible = true"></el-image>
              <div class="u-text-center u-font-14 c-font-color-c50000">{{ item.title }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :title="imgItem.title" :visible.sync="dialogVisible" width="30%">
      <div class="u-text-center">
        <el-image style="width: 255px;height: 250px;border: 2px solid #eaeaea;" :src="imgItem.filePath"
          fit="fill"></el-image>
      </div>
      <div class="u-text-center u-font-22 c-font-color-c50000 u-line-height-40">{{ imgItem.title }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      imgItem: {},
      imgList: []
    };
  },
  created() {
    this.getQcodeList();
  },
  methods: {
    getQcodeList() {
      // 图片管理-二维码
      this.$api.common.apiCommonImgList({ ids: '3' }).then(res => {
        this.imgList = res.data[0].imageList;
      });
    }
  }
};
</script>

<style></style>
